import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getCheckoutPrivacyConsentState = createSelector(getState, (state) => state.checkoutPrivacyConsent);
export const getCheckoutPrivacyConsentErrorState = createSelector(getCheckoutPrivacyConsentState, (state) => state.hasError);
